import { useState } from 'react';
import { LuTriangleAlert } from 'react-icons/lu';

import { Button } from '@/components/ui/button';

export type PolicyRetryQuery = { isError: boolean; refetch: () => Promise<unknown> };

/** Only failed dependencies are retried; successful queries and the rest of the page are untouched. */
export const PolicyQueryError = ({ message, queries }: { message: string; queries: PolicyRetryQuery[] }) => {
    const [retrying, setRetrying] = useState(false);
    const retry = async () => {
        setRetrying(true);
        try {
            await Promise.allSettled(queries.filter((query) => query.isError).map((query) => query.refetch()));
        } finally {
            setRetrying(false);
        }
    };
    return (
        <div role="alert" className="text-cocoa-700 flex flex-wrap items-center justify-center gap-3 px-6 py-6 text-sm">
            <LuTriangleAlert aria-hidden="true" className="size-4 shrink-0 text-amber-700" />
            <span>{message}</span>
            <Button variant="outline" size="sm" disabled={retrying} onClick={retry}>
                {retrying ? 'Retrying…' : 'Try again'}
            </Button>
        </div>
    );
};
